export default __webpack_public_path__ + "static/media/sms-cover.1ea3076d.jpg";